import { actionSubType } from '../components/pages/setting/clue/actionSubType';
import { Tags } from './Tags';

export const leadsTypeTree = [0, 12, 4, 6, 10, 5, 7, 2].map((key) => {
  const options = [];
  // 某些actionSubType有二级选择
  Object.keys(Tags.leadsSubTypeTag).map((leadsSubType) => {
    if (Tags.leadsSubTypeTag[leadsSubType].actionSubType == key && !Tags.leadsSubTypeTag[leadsSubType].hideInSelect) {
      options.push({
        value: leadsSubType,
        desc: Tags.leadsSubTypeTag[leadsSubType].desc,
        parentId: key,
        options: [],
      });
    }
  });
  return {
    value: key,
    desc: actionSubType[key],
    options,
  };
});

export const leadsTypeTreeForTableFilter = [0, 12, 4, 6, 10, 5, 7, 2].map((key) => {
  const options = [];
  // 某些actionSubType有二级选择
  Object.keys(Tags.leadsSubTypeTag).map((leadsSubType) => {
    if (Tags.leadsSubTypeTag[leadsSubType].actionSubType == key && !Tags.leadsSubTypeTag[leadsSubType].hideInSelect) {
      options.push({
        value: leadsSubType,
        desc: Tags.leadsSubTypeTag[leadsSubType].desc,
        parentId: key,
        options: [],
      });
    }
  });
  return {
    value: key,
    desc: actionSubType[key],
    options,
  };
});
